import styled from 'styled-components';
import { Button } from '@common/components/Button';
import { media } from 'styled-bootstrap-grid';
import SectionContainer from '@common/components/SectionContainer';

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 20px;
`;

export const HeroButton = styled(Button)`
  white-space: nowrap;
  margin: 0 5px 15px;
  width: 100%;

  ${media.md`
    width: initial;
  `}
`;

export const SectionTitle = styled.h2`
  font-size: 28px;
  font-family: ${({ theme }) => theme.headerFont};
  margin: 0;
  line-height: 39px;
`;

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  width: 100%;
  align-items: flex-start;

  button {
    width: 100%;

    ${media.md`
      width: initial;
    `}
  }
`;

export const SectionDescription = styled.div`
  display: none;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  line-height: 22px;

  ${media.md`
    display: block;
  `}
`;

export const SpaSectionContainer = styled(SectionContainer)`
  display: flex;
  flex-direction: column;
  margin-top: 50px;
`;
